import { DIVISION } from '@/types/league';

import Icon from './Icon';

export const getTransparentDivisionIcon = (
  divisionValue: DIVISION,
  size?: string,
) => {
  switch (divisionValue) {
    case 1:
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 121 96"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M120.73 12.3309L81.9493 57.373V95.045H92.9414H95.8685L120.73 65.0976V12.3309Z"
            stroke="#0BAEEA"
            strokeWidth="0.54"
          />
          <path
            d="M39.3162 95.045V57.373L0.535492 12.3309V65.0976L25.397 95.045H28.3241H39.3162Z"
            stroke="#0BAEEA"
            strokeWidth="0.54"
          />
          <path
            d="M45.9343 57.9455V95.047H74.787V57.9455L60.3607 1.09767L45.9343 57.9455Z"
            stroke="#0BAEEA"
            strokeWidth="0.54"
          />
        </svg>
      );
    case 2:
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 188 204"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.25 37.0672L55.43 99.0753V202.83H39.73H35.5217L0.25 163.435V37.0672Z"
            stroke="#0BAEEA"
            strokeWidth="0.54"
          />
          <path
            d="M132.33 202.83V99.0753L187.5 37.0672V163.435L152.228 202.83H148.02H132.33Z"
            stroke="#0BAEEA"
            strokeWidth="0.54"
          />
          <path
            d="M66.62 99.0131L93.03 0.961245L119.44 99.0131V139.184L98.8483 156.63H88.6171L66.62 139.179V99.0131Z"
            stroke="#0BAEEA"
            strokeWidth="0.54"
          />
          <path
            d="M66.5902 188.784L88.6444 163.321L98.8211 163.301L119.41 188.66L119.439 202.711L93.8295 202.771L66.6195 202.83L66.5902 188.784Z"
            stroke="#0BAEEA"
            strokeWidth="0.54"
          />
        </svg>
      );
    case 3:
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 184 233"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.12 218.571L35.5624 186.66H52.1V218.51V232.64H19.12V218.571Z"
            stroke="#0BAEEA"
            strokeWidth="0.54"
          />
          <path
            d="M91.79 186.66H98.5776L115.02 218.571V232.64H91.79H68.57V218.571L85.0025 186.66H91.79Z"
            stroke="#0BAEEA"
            strokeWidth="0.54"
          />
          <path
            d="M65.38 99.0131L91.79 0.961245L118.2 99.0131V157.32L98.6119 181.16H84.9682L65.38 157.32V99.0131Z"
            stroke="#0BAEEA"
            strokeWidth="0.54"
          />
          <path
            d="M35.52 181.16L0.25 142.693V16.5325L52.1 98.4624V181.16H35.52Z"
            stroke="#0BAEEA"
            strokeWidth="0.54"
          />
          <path
            d="M131.49 186.66H148.028L164.46 218.571V232.64H131.49V218.51V186.66Z"
            stroke="#0BAEEA"
            strokeWidth="0.54"
          />
          <path
            d="M131.49 98.4624L183.34 16.5325V142.693L148.07 181.16H131.49V98.4624Z"
            stroke="#0BAEEA"
            strokeWidth="0.54"
          />
        </svg>
      );
    case 4:
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 224 247"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.25 5.04946L71.08 83.3567V145.835L50.7878 168.65H45.4737L0.25 116.787V5.04946Z"
            stroke="#0BAEEA"
            strokeWidth="0.54"
          />
          <path
            d="M31.24 200.805L45.5074 175H50.7785L71.08 200.827V245.96H31.24V200.805Z"
            stroke="#0BAEEA"
            strokeWidth="0.54"
          />
          <path
            d="M172.881 168.65L152.38 145.835V83.3569L223.42 5.04805V116.787L178.196 168.65H172.881Z"
            stroke="#0BAEEA"
            strokeWidth="0.54"
          />
          <path
            d="M152.38 200.826L172.452 175H177.723L191.99 200.805V245.96H152.38V200.826Z"
            stroke="#0BAEEA"
            strokeWidth="0.54"
          />
          <path
            d="M137.73 145.826L115.067 168.34H106.886L85.0108 145.829L85.4797 83.301L111.372 4.87988L137.8 83.3007L137.73 145.826Z"
            stroke="#0BAEEA"
            strokeWidth="0.54"
          />
          <path
            d="M84.72 200.831L106.397 175H114.557L137.44 200.835V245.96H111.09H84.72V200.831Z"
            stroke="#0BAEEA"
            strokeWidth="0.54"
          />
          <path
            d="M78.7673 75.9638L37 29.7837V0.649077L85.817 54.6198L78.7673 75.9638Z"
            stroke="#0BAEEA"
            strokeWidth="0.54"
          />
          <path
            d="M144.683 75.9638L137.633 54.6198L186.45 0.649075V29.7837L144.683 75.9638Z"
            stroke="#0BAEEA"
            strokeWidth="0.54"
          />
        </svg>
      );
    default:
      return null;
  }
};

export const getDivisionIcon = (
  divisionValue: DIVISION,
  className?: string,
) => {
  switch (divisionValue) {
    case 1:
      return (
        <Icon name="Public" viewBox="0 0 219.02 164.59" className={className} />
      );
    case 2:
      return (
        <Icon
          name="Intermediate"
          viewBox="0 0 187.75 203.08"
          className={className}
        />
      );
    case 3:
      return (
        <Icon
          name="Masters"
          viewBox="0 0 183.59 232.89"
          className={className}
        />
      );
    case 4:
      return (
        <Icon
          name="Challenger"
          viewBox="0 0 223.67 246.21"
          className={className}
        />
      );
    default:
      return null;
  }
};
